import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUIDropdownMenuModule } from '../icons/core-ui-dropdown-menu/core-ui-dropdown-menu.module';
import { CoreUIIconsModule } from '../icons/core-ui-icons.module';
import { CoreUISkeletonModule } from '../skeleton/core-ui-skeleton.module';
import { CoreUIAttachmentCardActionDirective } from './attachment-card/core-ui-attachment-card-action.directive';
import { CoreUIAttachmentCardComponent } from './attachment-card/core-ui-attachment-card.component';
import { CoreUIMediaCardComponent } from './media-card/media-card.component';
import { CoreUIDocumentAttachmentCardComponent } from './document-attachment-card/document-attachment-card.component';
import { CoreUIStatCardComponent } from './stat-card/core-ui-stat-card.component';

@NgModule({
  declarations: [
    CoreUIStatCardComponent,
    CoreUIAttachmentCardActionDirective,
    CoreUIAttachmentCardComponent,
    CoreUIMediaCardComponent,
    CoreUIDocumentAttachmentCardComponent,
  ],
  imports: [CommonModule, CoreUIDropdownMenuModule, CoreUIIconsModule, CoreUISkeletonModule],
  exports: [
    CoreUIStatCardComponent,
    CoreUIAttachmentCardActionDirective,
    CoreUIAttachmentCardComponent,
    CoreUIMediaCardComponent,
    CoreUIDocumentAttachmentCardComponent,
  ],
})
export class CoreUiCardsModule {}
